import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Users from './Users'
import { actions } from '../../store'

const mapStateToProps = state => ({
  users: state.user.list,
  table: state.user.table,
  group: state.group,
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setModal: actions.modal.setModal,
  updateTable: actions.user.updateTable,
  activateUser: actions.user.activateUser,
  updateUserById: actions.user.updateUserById,

  getUsers: actions.user.getUsers,
  getGroups: actions.group.getGroups,
  getDivisions: actions.division.getDivisions
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users)



// WEBPACK FOOTER //
// ./src/views/Users/index.js